(() => {
  const tickPattern = /^\s*(?:✔|✓|☑|✅)\s*/;

  function stripLeadingTick(element) {
    const textNodes = [];
    const visit = (node) => {
      for (const child of node.childNodes) {
        if (child.nodeType === 3) textNodes.push(child);
        else if (child.nodeType === 1) visit(child);
      }
    };
    visit(element);

    for (const node of textNodes) {
      if (!node.nodeValue || !node.nodeValue.trim()) continue;
      node.nodeValue = node.nodeValue.replace(tickPattern, '');
      break;
    }
  }

  function convertTickParagraphs(description) {
    if (!description || description.dataset.cctvListsReady === 'true') return;

    let currentList = null;
    for (const child of Array.from(description.children)) {
      const isTickParagraph = child.tagName === 'P' && tickPattern.test(child.textContent || '');
      if (!isTickParagraph) {
        currentList = null;
        continue;
      }

      if (!currentList) {
        currentList = document.createElement('ul');
        currentList.className = 'cctv-feature-list';
        child.before(currentList);
      }

      const item = document.createElement('li');
      while (child.firstChild) item.appendChild(child.firstChild);
      stripLeadingTick(item);
      currentList.appendChild(item);
      child.remove();
    }

    description.dataset.cctvListsReady = 'true';
  }

  const run = () => document.querySelectorAll('.product__description.rte').forEach(convertTickParagraphs);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
